module.exports = __webpack_public_path__ + "static/img_stastny-45694e096a5d2196e5f76e7b9157f439.png";